/* ========================= MOCK DATA ========================= */

import { UserAccountType, SourceStatusEnum } from '@am3nd-org/pointcraft-types';

import { type Employee } from '../schemas/employee';
import { Customer, Transaction, ActivityItem, CustomerPaymentMethod } from '../types';

export const MOCK_CUSTOMERS: Customer[] = [
  {
    id: 'cust_a36b8524-1c5e-4f89-b2d3-7e8f9a0c1d2e',
    firstName: 'John',
    lastName: 'Doe',
    email: 'john.doe@example.com',
    phone: '+1234567890',
    totalSpent: 245075,
    joinedDate: new Date('2024-01-15'),
    transactionCount: 15,
  },
  {
    id: 'cust_b47c9635-2d6f-5g90-c3e4-8f9g0b1d2e3f',
    firstName: 'Jane',
    lastName: 'Smith',
    email: 'jane.smith@example.com',
    phone: '+1234567891',
    totalSpent: 189000,
    joinedDate: new Date('2024-02-20'),
    transactionCount: 12,
  },
  {
    id: 'cust_c58d0746-3e7g-6h01-d4f5-9g0h1c2e3f4g',
    firstName: 'Michael',
    lastName: 'Johnson',
    email: 'michael.j@example.com',
    phone: '+1234567892',
    totalSpent: 325025,
    joinedDate: new Date('2023-12-10'),
    transactionCount: 18,
  },
  {
    id: 'cust_d69e1857-4f8h-7i12-e5g6-0h1i2d3f4g5h',
    firstName: 'Emily',
    lastName: 'Davis',
    email: 'emily.davis@example.com',
    phone: '+1234567893',
    totalSpent: 56750,
    joinedDate: new Date('2024-03-05'),
    transactionCount: 5,
  },
  {
    id: 'cust_e70f2968-5g9i-8j23-f6h7-1i2j3e4g5h6i',
    firstName: 'Robert',
    lastName: 'Wilson',
    email: 'r.wilson@example.com',
    phone: '+1234567894',
    totalSpent: 142500,
    joinedDate: new Date('2024-01-28'),
    transactionCount: 10,
  },
  {
    id: 'cust_f81g3079-6h0j-9k34-g7i8-2j3k4f5h6i7j',
    firstName: 'Sarah',
    lastName: 'Martinez',
    email: 'sarah.m@example.com',
    phone: '+1234567895',
    totalSpent: 412080,
    joinedDate: new Date('2023-11-15'),
    transactionCount: 22,
  },
  {
    id: 'cust_g92h4180-7i1k-0l45-h8j9-3k4l5g6i7j8k',
    firstName: 'David',
    lastName: 'Lee',
    email: 'david.lee@example.com',
    phone: '+1234567896',
    totalSpent: 89040,
    joinedDate: new Date('2024-04-12'),
    transactionCount: 7,
  },
];
export const MOCK_TRANSACTIONS: Transaction[] = [
  // Sarah Martinez (22)
  {
    id: 'txn_f8a3b5c7-9d1e-4f2a-8b3c-5d6e7f8a9b0c',
    customerId: 'cust_f81g3079-6h0j-9k34-g7i8-2j3k4f5h6i7j',
    amount: 45000,
    status: SourceStatusEnum.PAID,
    type: 'payment',
    paymentMethod: 'card',
    date: new Date('2025-10-30'),
    description: 'Premium service',
    customerInfo: null,
  },
  {
    id: 'txn_a1b2c3d4-5e6f-7a8b-9c0d-1e2f3a4b5c6d',
    customerId: 'cust_f81g3079-6h0j-9k34-g7i8-2j3k4f5h6i7j',
    amount: 89000,
    status: SourceStatusEnum.PAID,
    type: 'payment',
    paymentMethod: 'mobile',
    date: new Date('2025-10-25'),
    description: 'Annual membership',
    customerInfo: null,
  },
  {
    id: 'txn_b2c3d4e5-6f7a-8b9c-0d1e-2f3a4b5c6d7e',
    customerId: 'cust_f81g3079-6h0j-9k34-g7i8-2j3k4f5h6i7j',
    amount: 15650,
    status: SourceStatusEnum.PAID,
    type: 'payment',
    paymentMethod: 'card',
    date: new Date('2025-10-10'),
    description: 'Event ticket',
    customerInfo: null,
  },
  {
    id: 'txn_c3d4e5f6-7a8b-9c0d-1e2f-3a4b5c6d7e8f',
    customerId: 'cust_f81g3079-6h0j-9k34-g7i8-2j3k4f5h6i7j',
    amount: 125000,
    status: SourceStatusEnum.PAID,
    type: 'payment',
    paymentMethod: 'bank_transfer',
    date: new Date('2025-10-13'),
    description: 'Enterprise license',
    customerInfo: null,
  },
  {
    id: 'txn_d4e5f6a7-8b9c-0d1e-2f3a-4b5c6d7e8f9a',
    customerId: 'cust_f81g3079-6h0j-9k34-g7i8-2j3k4f5h6i7j',
    amount: 32000,
    status: SourceStatusEnum.PAID,
    type: 'payment',
    paymentMethod: 'card',
    date: new Date('2025-10-05'),
    description: 'Monthly retainer',
    customerInfo: null,
  },
  {
    id: 'txn_e5f6a7b8-9c0d-1e2f-3a4b-5c6d7e8f9a0b',
    customerId: 'cust_f81g3079-6h0j-9k34-g7i8-2j3k4f5h6i7j',
    amount: 17580,
    status: SourceStatusEnum.PAID,
    type: 'payment',
    paymentMethod: 'mobile',
    date: new Date('2025-09-28'),
    description: 'Services',
    customerInfo: null,
  },
  {
    id: 'txn_f6a7b8c9-0d1e-2f3a-4b5c-6d7e8f9a0b1c',
    customerId: 'cust_f81g3079-6h0j-9k34-g7i8-2j3k4f5h6i7j',
    amount: 9500,
    status: SourceStatusEnum.PAID,
    type: 'payment',
    paymentMethod: 'card',
    date: new Date('2025-09-15'),
    description: 'Consultation',
    customerInfo: null,
  },
  {
    id: 'txn_a7b8c9d0-1e2f-3a4b-5c6d-7e8f9a0b1c2d',
    customerId: 'cust_f81g3079-6h0j-9k34-g7i8-2j3k4f5h6i7j',
    amount: 22050,
    status: SourceStatusEnum.PAID,
    type: 'payment',
    paymentMethod: 'card',
    date: new Date('2025-09-03'),
    description: 'Upgrade',
    customerInfo: null,
  },
  {
    id: 'txn_b8c9d0e1-2f3a-4b5c-6d7e-8f9a0b1c2d3e',
    customerId: 'cust_f81g3079-6h0j-9k34-g7i8-2j3k4f5h6i7j',
    amount: 6700,
    status: SourceStatusEnum.PAID,
    type: 'payment',
    paymentMethod: 'cash',
    date: new Date('2025-08-22'),
    description: 'Materials',
    customerInfo: null,
  },
  {
    id: 'txn_c9d0e1f2-3a4b-5c6d-7e8f-9a0b1c2d3e4f',
    customerId: 'cust_f81g3079-6h0j-9k34-g7i8-2j3k4f5h6i7j',
    amount: 14500,
    status: SourceStatusEnum.PAID,
    type: 'payment',
    paymentMethod: 'mobile',
    date: new Date('2025-08-20'),
    description: 'Training',
    customerInfo: null,
  },
  {
    id: 'txn_d0e1f2a3-4b5c-6d7e-8f9a-0b1c2d3e4f5a',
    customerId: 'cust_f81g3079-6h0j-9k34-g7i8-2j3k4f5h6i7j',
    amount: 9000,
    status: SourceStatusEnum.PAID,
    type: 'payment',
    paymentMethod: 'card',
    date: new Date('2025-09-18'),
    description: 'Support',
    customerInfo: null,
  },
  {
    id: 'txn_e1f2a3b4-5c6d-7e8f-9a0b-1c2d3e4f5a6b',
    customerId: 'cust_f81g3079-6h0j-9k34-g7i8-2j3k4f5h6i7j',
    amount: 19900,
    status: SourceStatusEnum.PAID,
    type: 'payment',
    paymentMethod: 'card',
    date: new Date('2025-09-12'),
    description: 'Features',
    customerInfo: null,
  },
  {
    id: 'txn_f2a3b4c5-6d7e-8f9a-0b1c-2d3e4f5a6b7c',
    customerId: 'cust_f81g3079-6h0j-9k34-g7i8-2j3k4f5h6i7j',
    amount: 5500,
    status: SourceStatusEnum.PAID,
    type: 'payment',
    paymentMethod: 'cash',
    date: new Date('2025-08-30'),
    description: 'Service',
    customerInfo: null,
  },
  {
    id: 'txn_a3b4c5d6-7e8f-9a0b-1c2d-3e4f5a6b7c8d',
    customerId: 'cust_f81g3079-6h0j-9k34-g7i8-2j3k4f5h6i7j',
    amount: 12500,
    status: SourceStatusEnum.PAID,
    type: 'payment',
    paymentMethod: 'mobile',
    date: new Date('2025-08-15'),
    description: 'Support',
    customerInfo: null,
  },
  {
    id: 'txn_b4c5d6e7-8f9a-0b1c-2d3e-4f5a6b7c8d9e',
    customerId: 'cust_f81g3079-6h0j-9k34-g7i8-2j3k4f5h6i7j',
    amount: 7800,
    status: SourceStatusEnum.PAID,
    type: 'payment',
    paymentMethod: 'card',
    date: new Date('2025-09-05'),
    description: 'Docs',
    customerInfo: null,
  },
  {
    id: 'txn_c5d6e7f8-9a0b-1c2d-3e4f-5a6b7c8d9e0f',
    customerId: 'cust_f81g3079-6h0j-9k34-g7i8-2j3k4f5h6i7j',
    amount: 34000,
    status: SourceStatusEnum.PAID,
    type: 'payment',
    paymentMethod: 'bank_transfer',
    date: new Date('2025-08-20'),
    description: 'Quarterly',
    customerInfo: null,
  },
  {
    id: 'txn_d6e7f8a9-0b1c-2d3e-4f5a-6b7c8d9e0f1a',
    customerId: 'cust_f81g3079-6h0j-9k34-g7i8-2j3k4f5h6i7j',
    amount: 9200,
    status: SourceStatusEnum.PAID,
    type: 'payment',
    paymentMethod: 'card',
    date: new Date('2025-08-08'),
    description: 'Hours',
    customerInfo: null,
  },
  {
    id: 'txn_e7f8a9b0-1c2d-3e4f-5a6b-7c8d9e0f1a2b',
    customerId: 'cust_f81g3079-6h0j-9k34-g7i8-2j3k4f5h6i7j',
    amount: 16700,
    status: SourceStatusEnum.PAID,
    type: 'payment',
    paymentMethod: 'mobile',
    date: new Date('2025-07-25'),
    description: 'Milestone',
    customerInfo: null,
  },
  {
    id: 'txn_f8a9b0c1-2d3e-4f5a-6b7c-8d9e0f1a2b3c',
    customerId: 'cust_f81g3079-6h0j-9k34-g7i8-2j3k4f5h6i7j',
    amount: 24500,
    status: SourceStatusEnum.PAID,
    type: 'payment',
    paymentMethod: 'card',
    date: new Date('2025-07-10'),
    description: 'Implementation',
    customerInfo: null,
  },
  {
    id: 'txn_a9b0c1d2-3e4f-5a6b-7c8d-9e0f1a2b3c4d',
    customerId: 'cust_f81g3079-6h0j-9k34-g7i8-2j3k4f5h6i7j',
    amount: 11200,
    status: SourceStatusEnum.PAID,
    type: 'payment',
    paymentMethod: 'card',
    date: new Date('2025-06-28'),
    description: 'Integration',
    customerInfo: null,
  },
  {
    id: 'txn_b0c1d2e3-4f5a-6b7c-8d9e-0f1a2b3c4d5e',
    customerId: 'cust_f81g3079-6h0j-9k34-g7i8-2j3k4f5h6i7j',
    amount: 18800,
    status: SourceStatusEnum.PAID,
    type: 'payment',
    paymentMethod: 'mobile',
    date: new Date('2025-06-15'),
    description: 'Development',
    customerInfo: null,
  },
  {
    id: 'txn_c1d2e3f4-5a6b-7c8d-9e0f-1a2b3c4d5e6f',
    customerId: 'cust_f81g3079-6h0j-9k34-g7i8-2j3k4f5h6i7j',
    amount: 14000,
    status: SourceStatusEnum.PAID,
    type: 'payment',
    paymentMethod: 'card',
    date: new Date('2025-06-01'),
    description: 'Setup',
    customerInfo: null,
  },
  // Michael Johnson (18)
  {
    id: 'txn_d2e3f4a5-6b7c-8d9e-0f1a-2b3c4d5e6f7a',
    customerId: 'cust_c58d0746-3e7g-6h01-d4f5-9g0h1c2e3f4g',
    amount: 32075,
    status: SourceStatusEnum.PAID,
    type: 'payment',
    paymentMethod: 'card',
    date: new Date('2025-10-28'),
    description: 'Subscription renewal',
    customerInfo: null,
  },
  {
    id: 'txn_e3f4a5b6-7c8d-9e0f-1a2b-3c4d5e6f7a8b',
    customerId: 'cust_c58d0746-3e7g-6h01-d4f5-9g0h1c2e3f4g',
    amount: 4500,
    status: SourceStatusEnum.REFUNDED,
    type: 'refund',
    paymentMethod: 'card',
    date: new Date('2025-10-24'),
    description: 'Refund',
    customerInfo: null,
  },
  {
    id: 'txn_f4a5b6c7-8d9e-0f1a-2b3c-4d5e6f7a8b9c',
    customerId: 'cust_c58d0746-3e7g-6h01-d4f5-9g0h1c2e3f4g',
    amount: 58000,
    status: SourceStatusEnum.PAID,
    type: 'payment',
    paymentMethod: 'card',
    date: new Date('2025-10-18'),
    description: 'Enterprise',
    customerInfo: null,
  },
  {
    id: 'txn_a5b6c7d8-9e0f-1a2b-3c4d-5e6f7a8b9c0d',
    customerId: 'cust_c58d0746-3e7g-6h01-d4f5-9g0h1c2e3f4g',
    amount: 19850,
    status: SourceStatusEnum.PAID,
    type: 'payment',
    paymentMethod: 'mobile',
    date: new Date('2025-10-01'),
    description: 'Upgrade',
    customerInfo: null,
  },
  {
    id: 'txn_b6c7d8e9-0f1a-2b3c-4d5e-6f7a8b9c0d1e',
    customerId: 'cust_c58d0746-3e7g-6h01-d4f5-9g0h1c2e3f4g',
    amount: 26700,
    status: SourceStatusEnum.PAID,
    type: 'payment',
    paymentMethod: 'card',
    date: new Date('2025-09-25'),
    description: 'Monthly',
    customerInfo: null,
  },
  {
    id: 'txn_c7d8e9f0-1a2b-3c4d-5e6f-7a8b9c0d1e2f',
    customerId: 'cust_c58d0746-3e7g-6h01-d4f5-9g0h1c2e3f4g',
    amount: 12500,
    status: SourceStatusEnum.PAID,
    type: 'payment',
    paymentMethod: 'card',
    date: new Date('2025-09-12'),
    description: 'Addons',
    customerInfo: null,
  },
  {
    id: 'txn_d8e9f0a1-2b3c-4d5e-6f7a-8b9c0d1e2f3a',
    customerId: 'cust_c58d0746-3e7g-6h01-d4f5-9g0h1c2e3f4g',
    amount: 44500,
    status: SourceStatusEnum.PAID,
    type: 'payment',
    paymentMethod: 'bank_transfer',
    date: new Date('2025-08-30'),
    description: 'Bulk',
    customerInfo: null,
  },
  {
    id: 'txn_e9f0a1b2-3c4d-5e6f-7a8b-9c0d1e2f3a4b',
    customerId: 'cust_c58d0746-3e7g-6h01-d4f5-9g0h1c2e3f4g',
    amount: 9000,
    status: SourceStatusEnum.PAID,
    type: 'payment',
    paymentMethod: 'mobile',
    date: new Date('2025-08-15'),
    description: 'Support',
    customerInfo: null,
  },
  {
    id: 'txn_f0a1b2c3-4d5e-6f7a-8b9c-0d1e2f3a4b5c',
    customerId: 'cust_c58d0746-3e7g-6h01-d4f5-9g0h1c2e3f4g',
    amount: 17500,
    status: SourceStatusEnum.PAID,
    type: 'payment',
    paymentMethod: 'card',
    date: new Date('2025-07-28'),
    description: 'Package',
    customerInfo: null,
  },
  {
    id: 'txn_a1b2c3d4-5e6f-7a8b-9c0d-1e2f3a4b5c6e',
    customerId: 'cust_c58d0746-3e7g-6h01-d4f5-9g0h1c2e3f4g',
    amount: 31200,
    status: SourceStatusEnum.PAID,
    type: 'payment',
    paymentMethod: 'card',
    date: new Date('2025-07-10'),
    description: 'Annual',
    customerInfo: null,
  },
  {
    id: 'txn_b2c3d4e5-6f7a-8b9c-0d1e-2f3a4b5c6d7f',
    customerId: 'cust_c58d0746-3e7g-6h01-d4f5-9g0h1c2e3f4g',
    amount: 6800,
    status: SourceStatusEnum.PAID,
    type: 'payment',
    paymentMethod: 'cash',
    date: new Date('2025-06-22'),
    description: 'Service',
    customerInfo: null,
  },
  {
    id: 'txn_c3d4e5f6-7a8b-9c0d-1e2f-3a4b5c6d7e8a',
    customerId: 'cust_c58d0746-3e7g-6h01-d4f5-9g0h1c2e3f4g',
    amount: 23400,
    status: SourceStatusEnum.PAID,
    type: 'payment',
    paymentMethod: 'mobile',
    date: new Date('2025-06-08'),
    description: 'Consulting',
    customerInfo: null,
  },
  {
    id: 'txn_d4e5f6a7-8b9c-0d1e-2f3a-4b5c6d7e8f9b',
    customerId: 'cust_c58d0746-3e7g-6h01-d4f5-9g0h1c2e3f4g',
    amount: 15600,
    status: SourceStatusEnum.PAID,
    type: 'payment',
    paymentMethod: 'card',
    date: new Date('2025-05-25'),
    description: 'Training',
    customerInfo: null,
  },
  {
    id: 'txn_e5f6a7b8-9c0d-1e2f-3a4b-5c6d7e8f9a0c',
    customerId: 'cust_c58d0746-3e7g-6h01-d4f5-9g0h1c2e3f4g',
    amount: 39800,
    status: SourceStatusEnum.PAID,
    type: 'payment',
    paymentMethod: 'card',
    date: new Date('2025-05-10'),
    description: 'Enterprise addon',
    customerInfo: null,
  },
  {
    id: 'txn_f6a7b8c9-0d1e-2f3a-4b5c-6d7e8f9a0b1d',
    customerId: 'cust_c58d0746-3e7g-6h01-d4f5-9g0h1c2e3f4g',
    amount: 12500,
    status: SourceStatusEnum.PAID,
    type: 'payment',
    paymentMethod: 'mobile',
    date: new Date('2025-04-28'),
    description: 'Fee',
    customerInfo: null,
  },
  {
    id: 'txn_a7b8c9d0-1e2f-3a4b-5c6d-7e8f9a0b1c2e',
    customerId: 'cust_c58d0746-3e7g-6h01-d4f5-9g0h1c2e3f4g',
    amount: 18900,
    status: SourceStatusEnum.PAID,
    type: 'payment',
    paymentMethod: 'card',
    date: new Date('2025-04-12'),
    description: 'Features',
    customerInfo: null,
  },
  {
    id: 'txn_b8c9d0e1-2f3a-4b5c-6d7e-8f9a0b1c2d3f',
    customerId: 'cust_c58d0746-3e7g-6h01-d4f5-9g0h1c2e3f4g',
    amount: 27800,
    status: SourceStatusEnum.PAID,
    type: 'payment',
    paymentMethod: 'bank_transfer',
    date: new Date('2025-03-30'),
    description: 'Quarterly',
    customerInfo: null,
  },
  {
    id: 'txn_c9d0e1f2-3a4b-5c6d-7e8f-9a0b1c2d3e4a',
    customerId: 'cust_c58d0746-3e7g-6h01-d4f5-9g0h1c2e3f4g',
    amount: 14400,
    status: SourceStatusEnum.PAID,
    type: 'payment',
    paymentMethod: 'card',
    date: new Date('2025-03-15'),
    description: 'Onboarding',
    customerInfo: null,
  },
  // John Doe (15)
  {
    id: 'txn_d0e1f2a3-4b5c-6d7e-8f9a-0b1c2d3e4f5b',
    customerId: 'cust_a36b8524-1c5e-4f89-b2d3-7e8f9a0c1d2e',
    amount: 12550,
    status: SourceStatusEnum.PAID,
    type: 'payment',
    paymentMethod: 'mobile',
    date: new Date('2025-10-29'),
    description: 'Product',
    customerInfo: null,
  },
  {
    id: 'txn_e1f2a3b4-5c6d-7e8f-9a0b-1c2d3e4f5a6c',
    customerId: 'cust_a36b8524-1c5e-4f89-b2d3-7e8f9a0c1d2e',
    amount: 23425,
    status: SourceStatusEnum.PAID,
    type: 'payment',
    paymentMethod: 'card',
    date: new Date('2025-10-23'),
    description: 'Consultation',
    customerInfo: null,
  },
  {
    id: 'txn_f2a3b4c5-6d7e-8f9a-0b1c-2d3e4f5a6b7d',
    customerId: 'cust_a36b8524-1c5e-4f89-b2d3-7e8f9a0c1d2e',
    amount: 6780,
    status: SourceStatusEnum.PAID,
    type: 'payment',
    paymentMethod: 'cash',
    date: new Date('2025-10-16'),
    description: 'Materials',
    customerInfo: null,
  },
  {
    id: 'txn_a3b4c5d6-7e8f-9a0b-1c2d-3e4f5a6b7c8e',
    customerId: 'cust_a36b8524-1c5e-4f89-b2d3-7e8f9a0c1d2e',
    amount: 18900,
    status: SourceStatusEnum.PAID,
    type: 'payment',
    paymentMethod: 'card',
    date: new Date('2025-10-05'),
    description: 'Upgrade',
    customerInfo: null,
  },
  {
    id: 'txn_b4c5d6e7-8f9a-0b1c-2d3e-4f5a6b7c8d9f',
    customerId: 'cust_a36b8524-1c5e-4f89-b2d3-7e8f9a0c1d2e',
    amount: 34550,
    status: SourceStatusEnum.PAID,
    type: 'payment',
    paymentMethod: 'mobile',
    date: new Date('2025-09-22'),
    description: 'Premium',
    customerInfo: null,
  },
  {
    id: 'txn_c5d6e7f8-9a0b-1c2d-3e4f-5a6b7c8d9e0a',
    customerId: 'cust_a36b8524-1c5e-4f89-b2d3-7e8f9a0c1d2e',
    amount: 7800,
    status: SourceStatusEnum.PAID,
    type: 'payment',
    paymentMethod: 'card',
    date: new Date('2025-09-10'),
    description: 'Addon',
    customerInfo: null,
  },
  {
    id: 'txn_d6e7f8a9-0b1c-2d3e-4f5a-6b7c8d9e0f1b',
    customerId: 'cust_a36b8524-1c5e-4f89-b2d3-7e8f9a0c1d2e',
    amount: 15700,
    status: SourceStatusEnum.PAID,
    type: 'payment',
    paymentMethod: 'cash',
    date: new Date('2025-08-28'),
    description: 'Workshop',
    customerInfo: null,
  },
  {
    id: 'txn_e7f8a9b0-1c2d-3e4f-5a6b-7c8d9e0f1a2c',
    customerId: 'cust_a36b8524-1c5e-4f89-b2d3-7e8f9a0c1d2e',
    amount: 29800,
    status: SourceStatusEnum.PAID,
    type: 'payment',
    paymentMethod: 'mobile',
    date: new Date('2025-08-15'),
    description: 'Subscription',
    customerInfo: null,
  },
  {
    id: 'txn_f8a9b0c1-2d3e-4f5a-6b7c-8d9e0f1a2b3d',
    customerId: 'cust_a36b8524-1c5e-4f89-b2d3-7e8f9a0c1d2e',
    amount: 12500,
    status: SourceStatusEnum.PAID,
    type: 'payment',
    paymentMethod: 'card',
    date: new Date('2025-07-30'),
    description: 'Support',
    customerInfo: null,
  },
  {
    id: 'txn_a9b0c1d2-3e4f-5a6b-7c8d-9e0f1a2b3c4e',
    customerId: 'cust_a36b8524-1c5e-4f89-b2d3-7e8f9a0c1d2e',
    amount: 19000,
    status: SourceStatusEnum.PAID,
    type: 'payment',
    paymentMethod: 'bank_transfer',
    date: new Date('2025-07-12'),
    description: 'Renewal',
    customerInfo: null,
  },
  {
    id: 'txn_b0c1d2e3-4f5a-6b7c-8d9e-0f1a2b3c4d5f',
    customerId: 'cust_a36b8524-1c5e-4f89-b2d3-7e8f9a0c1d2e',
    amount: 8950,
    status: SourceStatusEnum.PAID,
    type: 'payment',
    paymentMethod: 'card',
    date: new Date('2025-06-25'),
    description: 'Hours',
    customerInfo: null,
  },
  {
    id: 'txn_c1d2e3f4-5a6b-7c8d-9e0f-1a2b3c4d5e6a',
    customerId: 'cust_a36b8524-1c5e-4f89-b2d3-7e8f9a0c1d2e',
    amount: 16700,
    status: SourceStatusEnum.PAID,
    type: 'payment',
    paymentMethod: 'mobile',
    date: new Date('2025-06-10'),
    description: 'Project',
    customerInfo: null,
  },
  {
    id: 'txn_d2e3f4a5-6b7c-8d9e-0f1a-2b3c4d5e6f7b',
    customerId: 'cust_a36b8524-1c5e-4f89-b2d3-7e8f9a0c1d2e',
    amount: 23400,
    status: SourceStatusEnum.PAID,
    type: 'payment',
    paymentMethod: 'card',
    date: new Date('2025-05-28'),
    description: 'Session',
    customerInfo: null,
  },
  {
    id: 'txn_e3f4a5b6-7c8d-9e0f-1a2b-3c4d5e6f7a8c',
    customerId: 'cust_a36b8524-1c5e-4f89-b2d3-7e8f9a0c1d2e',
    amount: 19820,
    status: SourceStatusEnum.PAID,
    type: 'payment',
    paymentMethod: 'card',
    date: new Date('2025-05-15'),
    description: 'Training',
    customerInfo: null,
  },
  {
    id: 'txn_f4a5b6c7-8d9e-0f1a-2b3c-4d5e6f7a8b9d',
    customerId: 'cust_a36b8524-1c5e-4f89-b2d3-7e8f9a0c1d2e',
    amount: 15200,
    status: SourceStatusEnum.PAID,
    type: 'payment',
    paymentMethod: 'cash',
    date: new Date('2025-05-01'),
    description: 'Setup',
    customerInfo: null,
  },
  // Jane Smith (12)
  {
    id: 'txn_a5b6c7d8-9e0f-1a2b-3c4d-5e6f7a8b9c0e',
    customerId: 'cust_b47c9635-2d6f-5g90-c3e4-8f9g0b1d2e3f',
    amount: 8900,
    status: SourceStatusEnum.UNPAID,
    type: 'payment',
    paymentMethod: 'bank_transfer',
    date: new Date('2025-10-28'),
    description: 'Service',
    customerInfo: null,
  },
  {
    id: 'txn_b6c7d8e9-0f1a-2b3c-4d5e-6f7a8b9c0d1f',
    customerId: 'cust_b47c9635-2d6f-5g90-c3e4-8f9g0b1d2e3f',
    amount: 17800,
    status: SourceStatusEnum.PAID,
    type: 'payment',
    paymentMethod: 'cash',
    date: new Date('2025-10-22'),
    description: 'Custom order',
    customerInfo: null,
  },
  {
    id: 'txn_c7d8e9f0-1a2b-3c4d-5e6f-7a8b9c0d1e2a',
    customerId: 'cust_b47c9635-2d6f-5g90-c3e4-8f9g0b1d2e3f',
    amount: 34500,
    status: SourceStatusEnum.PAID,
    type: 'payment',
    paymentMethod: 'card',
    date: new Date('2025-10-15'),
    description: 'Professional',
    customerInfo: null,
  },
  {
    id: 'txn_d8e9f0a1-2b3c-4d5e-6f7a-8b9c0d1e2f3b',
    customerId: 'cust_b47c9635-2d6f-5g90-c3e4-8f9g0b1d2e3f',
    amount: 15650,
    status: SourceStatusEnum.PAID,
    type: 'payment',
    paymentMethod: 'mobile',
    date: new Date('2025-10-05'),
    description: 'Monthly',
    customerInfo: null,
  },
  {
    id: 'txn_e9f0a1b2-3c4d-5e6f-7a8b-9c0d1e2f3a4c',
    customerId: 'cust_b47c9635-2d6f-5g90-c3e4-8f9g0b1d2e3f',
    amount: 23400,
    status: SourceStatusEnum.PAID,
    type: 'payment',
    paymentMethod: 'card',
    date: new Date('2025-09-20'),
    description: 'Premium',
    customerInfo: null,
  },
  {
    id: 'txn_f0a1b2c3-4d5e-6f7a-8b9c-0d1e2f3a4b5d',
    customerId: 'cust_b47c9635-2d6f-5g90-c3e4-8f9g0b1d2e3f',
    amount: 12500,
    status: SourceStatusEnum.PAID,
    type: 'payment',
    paymentMethod: 'mobile',
    date: new Date('2025-09-08'),
    description: 'Addon',
    customerInfo: null,
  },
  {
    id: 'txn_a1b2c3d4-5e6f-7a8b-9c0d-1e2f3a4b5c6f',
    customerId: 'cust_b47c9635-2d6f-5g90-c3e4-8f9g0b1d2e3f',
    amount: 19850,
    status: SourceStatusEnum.PAID,
    type: 'payment',
    paymentMethod: 'card',
    date: new Date('2025-08-25'),
    description: 'Package',
    customerInfo: null,
  },
  {
    id: 'txn_b2c3d4e5-6f7a-8b9c-0d1e-2f3a4b5c6d7a',
    customerId: 'cust_b47c9635-2d6f-5g90-c3e4-8f9g0b1d2e3f',
    amount: 8900,
    status: SourceStatusEnum.PAID,
    type: 'payment',
    paymentMethod: 'cash',
    date: new Date('2025-08-20'),
    description: 'Service',
    customerInfo: null,
  },
  {
    id: 'txn_c3d4e5f6-7a8b-9c0d-1e2f-3a4b5c6d7e8b',
    customerId: 'cust_b47c9635-2d6f-5g90-c3e4-8f9g0b1d2e3f',
    amount: 26700,
    status: SourceStatusEnum.PAID,
    type: 'payment',
    paymentMethod: 'card',
    date: new Date('2025-07-28'),
    description: 'Consultation',
    customerInfo: null,
  },
  {
    id: 'txn_d4e5f6a7-8b9c-0d1e-2f3a-4b5c6d7e8f9c',
    customerId: 'cust_b47c9635-2d6f-5g90-c3e4-8f9g0b1d2e3f',
    amount: 14500,
    status: SourceStatusEnum.PAID,
    type: 'payment',
    paymentMethod: 'mobile',
    date: new Date('2025-07-15'),
    description: 'Training',
    customerInfo: null,
  },
  {
    id: 'txn_e5f6a7b8-9c0d-1e2f-3a4b-5c6d7e8f9a0d',
    customerId: 'cust_b47c9635-2d6f-5g90-c3e4-8f9g0b1d2e3f',
    amount: 17800,
    status: SourceStatusEnum.PAID,
    type: 'payment',
    paymentMethod: 'card',
    date: new Date('2025-06-30'),
    description: 'Project',
    customerInfo: null,
  },
  {
    id: 'txn_f6a7b8c9-0d1e-2f3a-4b5c-6d7e8f9a0b1e',
    customerId: 'cust_b47c9635-2d6f-5g90-c3e4-8f9g0b1d2e3f',
    amount: 8500,
    status: SourceStatusEnum.PAID,
    type: 'payment',
    paymentMethod: 'cash',
    date: new Date('2025-06-15'),
    description: 'Initial',
    customerInfo: null,
  },
  // Robert Wilson (10)
  {
    id: 'txn_a7b8c9d0-1e2f-3a4b-5c6d-7e8f9a0b1c2f',
    customerId: 'cust_e70f2968-5g9i-8j23-f6h7-1i2j3e4g5h6i',
    amount: 27500,
    status: SourceStatusEnum.PAID,
    type: 'payment',
    paymentMethod: 'cash',
    date: new Date('2025-10-27'),
    description: 'Workshop',
    customerInfo: null,
  },
  {
    id: 'txn_b8c9d0e1-2f3a-4b5c-6d7e-8f9a0b1c2d3a',
    customerId: 'cust_e70f2968-5g9i-8j23-f6h7-1i2j3e4g5h6i',
    amount: 9999,
    status: SourceStatusEnum.PAID,
    type: 'payment',
    paymentMethod: 'mobile',
    date: new Date('2025-10-21'),
    description: 'License',
    customerInfo: null,
  },
  {
    id: 'txn_c9d0e1f2-3a4b-5c6d-7e8f-9a0b1c2d3e4b',
    customerId: 'cust_e70f2968-5g9i-8j23-f6h7-1i2j3e4g5h6i',
    amount: 22050,
    status: SourceStatusEnum.PAID,
    type: 'payment',
    paymentMethod: 'mobile',
    date: new Date('2025-10-14'),
    description: 'Rental',
    customerInfo: null,
  },
  {
    id: 'txn_d0e1f2a3-4b5c-6d7e-8f9a-0b1c2d3e4f5c',
    customerId: 'cust_e70f2968-5g9i-8j23-f6h7-1i2j3e4g5h6i',
    amount: 15600,
    status: SourceStatusEnum.PAID,
    type: 'payment',
    paymentMethod: 'card',
    date: new Date('2025-10-05'),
    description: 'Subscription',
    customerInfo: null,
  },
  {
    id: 'txn_e1f2a3b4-5c6d-7e8f-9a0b-1c2d3e4f5a6d',
    customerId: 'cust_e70f2968-5g9i-8j23-f6h7-1i2j3e4g5h6i',
    amount: 18950,
    status: SourceStatusEnum.PAID,
    type: 'payment',
    paymentMethod: 'mobile',
    date: new Date('2025-09-22'),
    description: 'Package',
    customerInfo: null,
  },
  {
    id: 'txn_f2a3b4c5-6d7e-8f9a-0b1c-2d3e4f5a6b7e',
    customerId: 'cust_e70f2968-5g9i-8j23-f6h7-1i2j3e4g5h6i',
    amount: 12500,
    status: SourceStatusEnum.PAID,
    type: 'payment',
    paymentMethod: 'card',
    date: new Date('2025-09-10'),
    description: 'Course',
    customerInfo: null,
  },
  {
    id: 'txn_a3b4c5d6-7e8f-9a0b-1c2d-3e4f5a6b7c8f',
    customerId: 'cust_e70f2968-5g9i-8j23-f6h7-1i2j3e4g5h6i',
    amount: 7800,
    status: SourceStatusEnum.PAID,
    type: 'payment',
    paymentMethod: 'cash',
    date: new Date('2025-08-28'),
    description: 'Addon',
    customerInfo: null,
  },
  {
    id: 'txn_b4c5d6e7-8f9a-0b1c-2d3e-4f5a6b7c8d9a',
    customerId: 'cust_e70f2968-5g9i-8j23-f6h7-1i2j3e4g5h6i',
    amount: 14500,
    status: SourceStatusEnum.PAID,
    type: 'payment',
    paymentMethod: 'mobile',
    date: new Date('2025-08-15'),
    description: 'Consultation',
    customerInfo: null,
  },
  {
    id: 'txn_c5d6e7f8-9a0b-1c2d-3e4f-5a6b7c8d9e0b',
    customerId: 'cust_e70f2968-5g9i-8j23-f6h7-1i2j3e4g5h6i',
    amount: 8900,
    status: SourceStatusEnum.PAID,
    type: 'payment',
    paymentMethod: 'card',
    date: new Date('2025-07-30'),
    description: 'Service',
    customerInfo: null,
  },
  {
    id: 'txn_d6e7f8a9-0b1c-2d3e-4f5a-6b7c8d9e0f1c',
    customerId: 'cust_e70f2968-5g9i-8j23-f6h7-1i2j3e4g5h6i',
    amount: 4701,
    status: SourceStatusEnum.PAID,
    type: 'payment',
    paymentMethod: 'cash',
    date: new Date('2025-07-15'),
    description: 'Initial',
    customerInfo: null,
  },
  // David Lee (7)
  {
    id: 'txn_e7f8a9b0-1c2d-3e4f-5a6b-7c8d9e0f1a2d',
    customerId: 'cust_g92h4180-7i1k-0l45-h8j9-3k4l5g6i7j8k',
    amount: 15630,
    status: SourceStatusEnum.PAID,
    type: 'payment',
    paymentMethod: 'card',
    date: new Date('2025-10-26'),
    description: 'Bundle',
    customerInfo: null,
  },
  {
    id: 'txn_f8a9b0c1-2d3e-4f5a-6b7c-8d9e0f1a2b3e',
    customerId: 'cust_g92h4180-7i1k-0l45-h8j9-3k4l5g6i7j8k',
    amount: 41200,
    status: SourceStatusEnum.UNPAID,
    type: 'payment',
    paymentMethod: 'bank_transfer',
    date: new Date('2025-10-20'),
    description: 'Bulk',
    customerInfo: null,
  },
  {
    id: 'txn_a9b0c1d2-3e4f-5a6b-7c8d-9e0f1a2b3c4f',
    customerId: 'cust_g92h4180-7i1k-0l45-h8j9-3k4l5g6i7j8k',
    amount: 8950,
    status: SourceStatusEnum.PAID,
    type: 'payment',
    paymentMethod: 'card',
    date: new Date('2025-10-01'),
    description: 'Fee',
    customerInfo: null,
  },
  {
    id: 'txn_b0c1d2e3-4f5a-6b7c-8d9e-0f1a2b3c4d5a',
    customerId: 'cust_g92h4180-7i1k-0l45-h8j9-3k4l5g6i7j8k',
    amount: 12500,
    status: SourceStatusEnum.PAID,
    type: 'payment',
    paymentMethod: 'mobile',
    date: new Date('2025-09-25'),
    description: 'Monthly',
    customerInfo: null,
  },
  {
    id: 'txn_c1d2e3f4-5a6b-7c8d-9e0f-1a2b3c4d5e6b',
    customerId: 'cust_g92h4180-7i1k-0l45-h8j9-3k4l5g6i7j8k',
    amount: 6760,
    status: SourceStatusEnum.PAID,
    type: 'payment',
    paymentMethod: 'card',
    date: new Date('2025-09-10'),
    description: 'Addon',
    customerInfo: null,
  },
  {
    id: 'txn_d2e3f4a5-6b7c-8d9e-0f1a-2b3c4d5e6f7c',
    customerId: 'cust_g92h4180-7i1k-0l45-h8j9-3k4l5g6i7j8k',
    amount: 2800,
    status: SourceStatusEnum.PAID,
    type: 'payment',
    paymentMethod: 'cash',
    date: new Date('2025-08-28'),
    description: 'Service',
    customerInfo: null,
  },
  {
    id: 'txn_e3f4a5b6-7c8d-9e0f-1a2b-3c4d5e6f7a8d',
    customerId: 'cust_g92h4180-7i1k-0l45-h8j9-3k4l5g6i7j8k',
    amount: 1200,
    status: SourceStatusEnum.PAID,
    type: 'payment',
    paymentMethod: 'cash',
    date: new Date('2025-08-15'),
    description: 'Initial',
    customerInfo: null,
  },
  // Emily Davis (5)
  {
    id: 'txn_f4a5b6c7-8d9e-0f1a-2b3c-4d5e6f7a8b9e',
    customerId: 'cust_d69e1857-4f8h-7i12-e5g6-0h1i2d3f4g5h',
    amount: 6750,
    status: SourceStatusEnum.FAILED_FINAL,
    type: 'payment',
    paymentMethod: 'card',
    date: new Date('2025-10-26'),
    description: 'Course',
    customerInfo: null,
  },
  {
    id: 'txn_a5b6c7d8-9e0f-1a2b-3c4d-5e6f7a8b9c0f',
    customerId: 'cust_d69e1857-4f8h-7i12-e5g6-0h1i2d3f4g5h',
    amount: 12500,
    status: SourceStatusEnum.PAID,
    type: 'payment',
    paymentMethod: 'mobile',
    date: new Date('2025-10-17'),
    description: 'Subscription',
    customerInfo: null,
  },
  {
    id: 'txn_b6c7d8e9-0f1a-2b3c-4d5e-6f7a8b9c0d1a',
    customerId: 'cust_d69e1857-4f8h-7i12-e5g6-0h1i2d3f4g5h',
    amount: 15600,
    status: SourceStatusEnum.PAID,
    type: 'payment',
    paymentMethod: 'card',
    date: new Date('2025-10-05'),
    description: 'Package',
    customerInfo: null,
  },
  {
    id: 'txn_c7d8e9f0-1a2b-3c4d-5e6f-7a8b9c0d1e2b',
    customerId: 'cust_d69e1857-4f8h-7i12-e5g6-0h1i2d3f4g5h',
    amount: 8900,
    status: SourceStatusEnum.PAID,
    type: 'payment',
    paymentMethod: 'mobile',
    date: new Date('2025-09-22'),
    description: 'Materials',
    customerInfo: null,
  },
  {
    id: 'txn_d8e9f0a1-2b3c-4d5e-6f7a-8b9c0d1e2f3c',
    customerId: 'cust_d69e1857-4f8h-7i12-e5g6-0h1i2d3f4g5h',
    amount: 13000,
    status: SourceStatusEnum.PAID,
    type: 'payment',
    paymentMethod: 'card',
    date: new Date('2025-09-10'),
    description: 'Setup',
    customerInfo: null,
  },
];

export const MOCK_ACTIVITIES: ActivityItem[] = [
  {
    id: 'act_a1b2c3d4-5e6f-7a8b-9c0d-1e2f3a4b5c6d',
    type: 'transaction',
    title: 'Payment received',
    description: '$450.00 from Sarah Martinez',
    timestamp: new Date('2025-10-30T14:30:00'),
    icon: 'solar:bill-check-bold',
    color: '#16a34a',
  },
  {
    id: 'act_b2c3d4e5-6f7a-8b9c-0d1e-2f3a4b5c6d7e',
    type: 'transaction',
    title: 'Payment received',
    description: '$125.50 from John Doe',
    timestamp: new Date('2025-10-29T10:15:00'),
    icon: 'solar:bill-check-bold',
    color: '#16a34a',
  },
  {
    id: 'act_c3d4e5f6-7a8b-9c0d-1e2f-3a4b5c6d7e8f',
    type: 'transaction',
    title: 'Payment received',
    description: '$320.75 from Michael Johnson',
    timestamp: new Date('2025-10-28T16:45:00'),
    icon: 'solar:bill-check-bold',
    color: '#16a34a',
  },
  {
    id: 'act_d4e5f6a7-8b9c-0d1e-2f3a-4b5c6d7e8f9a',
    type: 'transaction',
    title: 'Payment pending',
    description: '$89.00 from Jane Smith',
    timestamp: new Date('2025-10-28T09:20:00'),
    icon: 'solar:clock-circle-bold',
    color: '#f59e0b',
  },
  {
    id: 'act_e5f6a7b8-9c0d-1e2f-3a4b-5c6d7e8f9a0b',
    type: 'transaction',
    title: 'Payment received',
    description: '$275.00 from Robert Wilson',
    timestamp: new Date('2025-10-27T13:00:00'),
    icon: 'solar:bill-check-bold',
    color: '#16a34a',
  },
  {
    id: 'act_f6a7b8c9-0d1e-2f3a-4b5c-6d7e8f9a0b1c',
    type: 'transaction',
    title: 'Payment failed',
    description: '$67.50 from Emily Davis',
    timestamp: new Date('2025-10-26T11:30:00'),
    icon: 'solar:close-circle-bold',
    color: '#ef4444',
  },
  {
    id: 'act_a7b8c9d0-1e2f-3a4b-5c6d-7e8f9a0b1c2d',
    type: 'transaction',
    title: 'Large payment',
    description: '$890.00 from Sarah Martinez',
    timestamp: new Date('2025-10-25T15:45:00'),
    icon: 'solar:bill-check-bold',
    color: '#16a34a',
  },
  {
    id: 'act_b8c9d0e1-2f3a-4b5c-6d7e-8f9a0b1c2d3e',
    type: 'refund',
    title: 'Refund processed',
    description: '$45.00 to Michael Johnson',
    timestamp: new Date('2025-10-24T10:00:00'),
    icon: 'solar:undo-left-bold',
    color: '#6366f1',
  },
  {
    id: 'act_c9d0e1f2-3a4b-5c6d-7e8f-9a0b1c2d3e4f',
    type: 'customer',
    title: 'New customer',
    description: 'David Lee joined',
    timestamp: new Date('2025-10-23T14:20:00'),
    icon: 'solar:user-check-bold',
    color: '#2563eb',
  },
  {
    id: 'act_d0e1f2a3-4b5c-6d7e-8f9a-0b1c2d3e4f5a',
    type: 'payout',
    title: 'Payout completed',
    description: '$5,420.00 transferred',
    timestamp: new Date('2025-10-22T09:00:00'),
    icon: 'solar:wallet-money-bold',
    color: '#ec4899',
  },
];

export const MOCK_EMPLOYEES: Employee[] = [
  {
    id: 'emp_a1b2c3d4-5e6f-7a8b-9c0d-1e2f3a4b5c6d',
    name: 'Medo',
    email: 'medo@mail.com',
    phone: '+1234567890',
    role: UserAccountType.BUSINESS_MANAGER,
    status: 'active',
    permissions: ['manage_customers', 'manage_transactions'],
    joinedDate: new Date('2025-10-22'),
    address: {
      street1: '456 Employee Ave',
      street2: 'Apt 2B',
      city: 'Los Angeles',
      state: 'CA',
      postalCode: '90001',
      country: 'US',
    },
  },
];

// NOTE: MOCK_PLANS has been removed. Plans are now fetched from the API.

export const MOCK_PAYMENT_METHODS: CustomerPaymentMethod[] = [
  // John Doe – 3 methods (card default, bank, mobile)
  {
    id: 'pm_9f9b8c3e-5d24-4b0b-8f1d-0a1c2b3d4e5f',
    customer_id: 'cust_a36b8524-1c5e-4f89-b2d3-7e8f9a0c1d2e',
    method: 'card',
    cardNumber: '4242424242424242',
    cardholderName: 'John Doe',
    expiryDate: '12/27',
    cvv: '123',
    description: 'Personal Visa',
    isDefault: false,
    createdAt: new Date('2025-01-05').toISOString(),
  },
  {
    id: 'pm_1d2c3b4a-6e35-4c1d-9e2f-1a2b3c4d5e6f',
    customer_id: 'cust_a36b8524-1c5e-4f89-b2d3-7e8f9a0c1d2e',
    method: 'bank_transfer',
    bankName: 'Chase Bank',
    accountNumber: '123456789012',
    routingNumber: '110000000',
    description: 'Business checking',
    isDefault: true,
    createdAt: new Date('2025-01-10').toISOString(),
  },
  {
    id: 'pm_2e3f4a5b-7f46-4e2e-a103-2b3c4d5e6f70',
    customer_id: 'cust_a36b8524-1c5e-4f89-b2d3-7e8f9a0c1d2e',
    method: 'mobile',
    walletProvider: 'PayPal',
    phoneNumber: '+1234567890',
    description: 'John PayPal',
    isDefault: false,
    createdAt: new Date('2025-02-01').toISOString(),
  },

  // Jane Smith – 3 methods (card default, bank, mobile)
  {
    id: 'pm_3f4a5b6c-8f57-4f3f-b214-3c4d5e6f7081',
    customer_id: 'cust_b47c9635-2d6f-5g90-c3e4-8f9g0b1d2e3f',
    method: 'card',
    cardNumber: '4000056655665556',
    cardholderName: 'Jane Smith',
    expiryDate: '08/26',
    cvv: '456',
    description: 'Primary Visa',
    isDefault: true,
    createdAt: new Date('2025-02-05').toISOString(),
  },
  {
    id: 'pm_4a5b6c7d-9f68-4040-c325-4d5e6f708192',
    customer_id: 'cust_b47c9635-2d6f-5g90-c3e4-8f9g0b1d2e3f',
    method: 'bank_transfer',
    bankName: 'Wells Fargo',
    accountNumber: '223344556677',
    routingNumber: '121000248',
    description: 'Savings account',
    isDefault: false,
    createdAt: new Date('2025-02-10').toISOString(),
  },
  {
    id: 'pm_5b6c7d8e-af79-4151-d436-5e6f708192a3',
    customer_id: 'cust_b47c9635-2d6f-5g90-c3e4-8f9g0b1d2e3f',
    method: 'mobile',
    walletProvider: 'Apple Pay',
    phoneNumber: '+1234567891',
    description: 'iPhone wallet',
    isDefault: false,
    createdAt: new Date('2025-02-18').toISOString(),
  },

  // Michael Johnson – 3 methods (card default, bank, mobile)
  {
    id: 'pm_6c7d8e9f-bf8a-4262-e547-6f708192a3b4',
    customer_id: 'cust_c58d0746-3e7g-6h01-d4f5-9g0h1c2e3f4g',
    method: 'card',
    cardNumber: '5555555555554444',
    cardholderName: 'Michael Johnson',
    expiryDate: '03/28',
    cvv: '789',
    description: 'Business Mastercard',
    isDefault: true,
    createdAt: new Date('2024-12-05').toISOString(),
  },
  {
    id: 'pm_7d8e9f0a-cf9b-4373-f658-708192a3b4c5',
    customer_id: 'cust_c58d0746-3e7g-6h01-d4f5-9g0h1c2e3f4g',
    method: 'bank_transfer',
    bankName: 'Citibank',
    accountNumber: '334455667788',
    routingNumber: '021000089',
    description: 'Corporate account',
    isDefault: false,
    createdAt: new Date('2024-12-12').toISOString(),
  },
  {
    id: 'pm_8e9f0a1b-d0ac-4484-0769-8192a3b4c5d6',
    customer_id: 'cust_c58d0746-3e7g-6h01-d4f5-9g0h1c2e3f4g',
    method: 'mobile',
    walletProvider: 'Google Pay',
    phoneNumber: '+1234567892',
    description: 'Android wallet',
    isDefault: false,
    createdAt: new Date('2024-12-20').toISOString(),
  },

  // Emily Davis – 2 methods (card default, mobile)
  {
    id: 'pm_9f0a1b2c-e1bd-4595-187a-92a3b4c5d6e7',
    customer_id: 'cust_d69e1857-4f8h-7i12-e5g6-0h1i2d3f4g5h',
    method: 'card',
    cardNumber: '4111111111111111',
    cardholderName: 'Emily Davis',
    expiryDate: '07/26',
    cvv: '321',
    description: 'Personal Visa',
    isDefault: true,
    createdAt: new Date('2024-03-10').toISOString(),
  },
  {
    id: 'pm_a0b1c2d3-f2ce-46a6-298b-a3b4c5d6e7f8',
    customer_id: 'cust_d69e1857-4f8h-7i12-e5g6-0h1i2d3f4g5h',
    method: 'mobile',
    walletProvider: 'Venmo',
    phoneNumber: '+1234567893',
    description: 'Emily Venmo',
    isDefault: false,
    createdAt: new Date('2024-03-18').toISOString(),
  },

  // Robert Wilson – 3 methods (card default, bank, mobile)
  {
    id: 'pm_b1c2d3e4-03df-47b7-3a9c-b4c5d6e7f809',
    customer_id: 'cust_e70f2968-5g9i-8j23-f6h7-1i2j3e4g5h6i',
    method: 'card',
    cardNumber: '4012888888881881',
    cardholderName: 'Robert Wilson',
    expiryDate: '10/27',
    cvv: '654',
    description: 'Primary card',
    isDefault: true,
    createdAt: new Date('2024-01-30').toISOString(),
  },
  {
    id: 'pm_c2d3e4f5-14e0-48c8-4bad-c5d6e7f8091a',
    customer_id: 'cust_e70f2968-5g9i-8j23-f6h7-1i2j3e4g5h6i',
    method: 'bank_transfer',
    bankName: 'HSBC',
    accountNumber: '445566778899',
    routingNumber: '031000053',
    description: 'Main checking',
    isDefault: false,
    createdAt: new Date('2024-02-05').toISOString(),
  },
  {
    id: 'pm_d3e4f5a6-25f1-49d9-5cbe-d6e7f8091a2b',
    customer_id: 'cust_e70f2968-5g9i-8j23-f6h7-1i2j3e4g5h6i',
    method: 'mobile',
    walletProvider: 'Cash App',
    phoneNumber: '+1234567894',
    description: 'Robert Cash App',
    isDefault: false,
    createdAt: new Date('2024-02-12').toISOString(),
  },

  // Sarah Martinez – 4 methods (card default, bank, mobile, cash)
  {
    id: 'pm_e4f5a6b7-3602-4ae0-6dcf-e7f8091a2b3c',
    customer_id: 'cust_f81g3079-6h0j-9k34-g7i8-2j3k4f5h6i7j',
    method: 'card',
    cardNumber: '5200828282828210',
    cardholderName: 'Sarah Martinez',
    expiryDate: '09/28',
    cvv: '987',
    description: 'Premium Mastercard',
    isDefault: true,
    createdAt: new Date('2023-11-20').toISOString(),
  },
  {
    id: 'pm_f5a6b7c8-4713-4bf1-7ed0-f8091a2b3c4d',
    customer_id: 'cust_f81g3079-6h0j-9k34-g7i8-2j3k4f5h6i7j',
    method: 'bank_transfer',
    bankName: 'Bank of America',
    accountNumber: '556677889900',
    routingNumber: '026009593',
    description: 'High-yield account',
    isDefault: false,
    createdAt: new Date('2023-11-25').toISOString(),
  },
  {
    id: 'pm_06a7b8c9-5824-4c02-8fe1-091a2b3c4d5e',
    customer_id: 'cust_f81g3079-6h0j-9k34-g7i8-2j3k4f5h6i7j',
    method: 'mobile',
    walletProvider: 'Stripe Link',
    phoneNumber: '+1234567895',
    description: 'Sarah Link wallet',
    isDefault: false,
    createdAt: new Date('2023-12-01').toISOString(),
  },
  {
    id: 'pm_17b8c9d0-6935-4d13-9012-1a2b3c4d5e6f',
    customer_id: 'cust_f81g3079-6h0j-9k34-g7i8-2j3k4f5h6i7j',
    method: 'cash',
    description: 'Pays often in cash',
    isDefault: false,
    createdAt: new Date('2023-12-05').toISOString(),
  },

  // David Lee – 3 methods (mobile default, plus card, bank)
  {
    id: 'pm_28c9d0e1-7a46-4e24-a123-2b3c4d5e6f70',
    customer_id: 'cust_g92h4180-7i1k-0l45-h8j9-3k4l5g6i7j8k',
    method: 'mobile',
    walletProvider: 'PayPal',
    phoneNumber: '+1234567896',
    description: 'David PayPal',
    isDefault: true,
    createdAt: new Date('2025-02-03').toISOString(),
  },
  {
    id: 'pm_39d0e1f2-8b57-4f35-b234-3c4d5e6f7081',
    customer_id: 'cust_g92h4180-7i1k-0l45-h8j9-3k4l5g6i7j8k',
    method: 'card',
    cardNumber: '4000002500003155',
    cardholderName: 'David Lee',
    expiryDate: '04/27',
    cvv: '159',
    description: 'Online purchases card',
    isDefault: false,
    createdAt: new Date('2025-02-10').toISOString(),
  },
  {
    id: 'pm_4ae1f203-9c68-4046-c345-4d5e6f708192',
    customer_id: 'cust_g92h4180-7i1k-0l45-h8j9-3k4l5g6i7j8k',
    method: 'bank_transfer',
    bankName: 'TD Bank',
    accountNumber: '667788990011',
    routingNumber: '031101266',
    description: 'Salary account',
    isDefault: false,
    createdAt: new Date('2025-02-15').toISOString(),
  },
];
